/**
 * The "Practice" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const PRACTICE_ITEMS = [
  {
    href: "/simulator",
    label: "Practice Scenarios",
    shortcut: "S",
    iconName: "LiaTheaterMasksSolid",
    requires: "workspace",
    // The modules the Practice Scenarios page launches, listed under it. Each
    // shows when the studio runs it; the studio's own name for it replaces
    // the label (`moduleLabels: "practice"`).
    subItems: [
      {
        href: "/simulator/discovery",
        label: "Discovery",
        iconName: "CiMap",
        requires: "practiceModule",
      },
      {
        href: "/simulator/pitch",
        label: "Messaging / Pitch",
        iconName: "HiOutlinePresentationChartBar",
        requires: "practiceModule",
      },
      {
        href: "/simulator/objections",
        label: "Objections",
        iconName: "HiNoSymbol",
        requires: "practiceModule",
      },
      {
        href: "/simulator/cold-call",
        label: "Outbound & Inbounds",
        iconName: "IoCallOutline",
        requires: "practiceModule",
      },
      {
        href: "/simulator/plays",
        label: "Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "practiceModule",
      },
      {
        href: "/simulator/management",
        label: "Management Practice",
        iconName: "HiOutlineUserGroup",
        requires: ["practiceModule", "supervisorOrAbove"],
      },
      {
        href: "/simulator/on-the-fly",
        label: "On-the-fly Plays",
        iconName: "LiaTheaterMasksSolid",
        requires: "practiceModule",
      },
      {
        href: "/dashboard/conversation-analyzer",
        label: "Conversation Analysis",
        iconName: "IoStatsChartOutline",
        requires: "practiceModule",
      },
      {
        href: "/dem-cog/reports",
        label: "Deal Clinic",
        iconName: "IoBarChartOutline",
        requires: "practiceModule",
      },
      {
        href: "/stories",
        label: "Stories",
        iconName: "IoBookOutline",
        requires: "stories",
      },
    ],
  },
  {
    href: "/simulator/personas",
    label: "Personas",
    iconName: "IoPersonOutline",
    requires: "workspace",
  },
  {
    href: "/simulator/seller-personas",
    label: "Other Personas",
    iconName: "IoPeopleOutline",
    requires: ["workspace", "management", "supervisorOrAbove"],
  },
];
